webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(148);
	module.exports = __webpack_require__(125);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var projects = [{
	  title: 'Incubes',
	  description: '<p>In an era of robust global trade, shipping containers are ubiquitous. Strong, durable and produced en mass, they also represent a dynamic solution to the critical affordable housing shortages that face many of today\u2019s growing cities.</p>\n\n    <p>The visual identity and website is based on a functional and modular grid system that clearly references the the modularity in container housing. We aimed for a corporate yet playful identity. The website is based on a light custom vw-based CSS framework for a square website grid.</p>',
	  year: 2017,
	  url: 'incubes.dk',
	  path: '/incubes',
	  images: ['/static/images/incubes/business-card-1-web.jpg', '/static/images/incubes/incubes-logo-3.jpg'],
	  fields: ['Creative direction', 'Branding', 'Identity', 'Web']
	}, {
	  title: 'Clean Sound',
	  description: '<p>In 1971, AM started developing products to make your analogue audio collection deliver the cleanest sound possible. Sound that makes you feel as though you\u2019re there in the recording studio. A 3D, tangible music experience.</p>\n\n    <p>The packaging back then was inspired by modernist functionalism, the simplified forms of AM products transcend their everyday function.\n    Every object has been reduced to an essential form, erased of unnecessary detail. The products, packaging and visual identity we have developed for AM share the same palette of black and white as the original AM graphics of the 1970s, the same honesty and robustness. It\u2019s a language of fetishized simplicity.</p>\n\n    <p>We have worked closely with AM from idea to execution. Our tasks have included product design, packaging, visual identity, partnerships and collaborations, supply chain, logistics, PR, marketing, digital strategy, retail strategy and sales.</p>',
	  year: 2016,
	  url: 'cleansoundam.com',
	  path: '/clean-sound',
	  images: ['/static/images/clean-sound/wooden-box-closeup.jpg'],
	  fields: ['Creative direction', 'Branding', 'Identity', 'Web']
	}, {
	  title: 'Get Clean',
	  description: '<p>For the most part, nobody likes to clean, it\u2019s just not very fun. But we all love to have good look\u2019n devices. What if we actually wanted to clean because the things we\u2019d use for cleaning made it fun? Complimenting our favourite gadgets, the tools we use to clean with should look great &mdash; feel great &mdash; and perform great.</p>\n\n    <p>We have worked closely with AM from idea to execution. Our tasks have included product design, packaging, visual identity, partnerships and collaborations, supply chain, logistics, PR, marketing, digital strategy, retail strategy and sales.</p>\n\n    <p>We wanted to expose the dirty truth about our filthy gadgets. We came up with some gross statements and teamed up with artist Geoff McFetridge to create some fun illustrations to match the "dirty facts". On product design and packaging we worked with New York based Aruliden, and stop-motion animations are made in collaboration with Todd St. John and his animation studio HunterGatherer.</p>',
	  year: 2016,
	  url: 'getcleanam.com',
	  path: '/get-clean',
	  images: ['/static/images/get-clean/process-2.jpg'],
	  fields: ['Creative direction', 'Branding', 'Identity', 'Web'],
	  awards: ['Red Dot Design Award', 'Core 77 Design Awards', 'German Design Award', 'IDEA', 'The Dyeline Awards', "Art Directors' Club", 'American Packaging Design Award']
	}];
	
	exports.default = projects;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(372);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(370);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _WebsiteVideo = __webpack_require__(123);
	
	var _WebsiteVideo2 = _interopRequireDefault(_WebsiteVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ProjectHeader: _Header2.default,
	    ProjectFooter: _Footer2.default,
	    WebsiteVideo: _WebsiteVideo2.default
	  }
	};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _throttle = __webpack_require__(358);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      videos: null,
	      supportsPassive: false,
	      windowHeight: window.innerHeight || document.documentElement.clientHeight,
	      eventHandler: null
	    };
	  },
	  mounted: function mounted() {
	    this.setSupportsPassive();
	    this.videos = document.querySelectorAll('video:not(.no-scrollplay)');
	    this.eventHandler = (0, _throttle2.default)(this.handleScroll, 200);
	    window.addEventListener('scroll', this.eventHandler, this.supportsPassive ? { passive: true } : false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('scroll', this.eventHandler);
	  },
	
	  methods: {
	    setSupportsPassive: function setSupportsPassive() {
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          get: function get() {
	            this.supportsPassive = true;
	          }
	        });
	        window.addEventListener('test', null, opts);
	      } catch (e) {}
	    },
	    handleScroll: function handleScroll() {
	      if (!this.videos) return;
	
	      this.setWindowHeight();
	      var viewFactor = 1;
	
	      for (var i = 0; i < this.videos.length; i++) {
	        this.playIfInView(this.videos[i], viewFactor);
	      }
	    },
	    playIfInView: function playIfInView(video, viewFactor) {
	      var boundingClientRect = video.getBoundingClientRect();
	
	      if (boundingClientRect.top >= -boundingClientRect.height * viewFactor && boundingClientRect.bottom <= this.windowHeight + boundingClientRect.height * viewFactor) {
	        video.play();
	      } else {
	        video.pause();
	      }
	    },
	    setWindowHeight: function setWindowHeight() {
	      this.windowHeight = window.innerHeight || document.documentElement.clientHeight;
	    }
	  }
	};

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var store = {
	  contact: {
	    email: "fm@tyfc.co",
	    street: "Heimdalsgade 37B",
	    postal_code: "2200",
	    city: "Copenhagen N",
	    country: "Denmark"
	  },
	  jobs: []
	};
	
	exports.default = store;

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(334)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(131),
	  /* template */
	  __webpack_require__(381),
	  /* scopeId */
	  "data-v-0ba8366c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(342)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(136),
	  /* template */
	  __webpack_require__(389),
	  /* scopeId */
	  "data-v-5b55446f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(124);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(361);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(126);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _isTouchDevice = __webpack_require__(128);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(330);
	
	window.isTouch = (0, _isTouchDevice2.default)();
	
	new _vue2.default({
	  el: '#app',
	  router: _router2.default,
	  template: '<App />',
	  components: {
	    App: _App2.default
	  }
	});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(124);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(397);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(127);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  mode: 'history'
	});
	
	exports.default = router;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [{
	  path: '/',
	  name: 'index',
	  component: __webpack_require__(365)
	}, {
	  path: '/about',
	  name: 'about',
	  component: __webpack_require__(362)
	}, {
	  path: '/contact',
	  name: 'contact',
	  component: __webpack_require__(363)
	}, {
	  path: '/work',
	  component: __webpack_require__(375),
	  children: [{
	    path: '',
	    name: 'work',
	    component: __webpack_require__(376)
	  }, {
	    path: 'incubes',
	    name: 'incubes',
	    component: __webpack_require__(374)
	  }, {
	    path: 'clean-sound',
	    name: 'clean-sound',
	    component: __webpack_require__(368)
	  }, {
	    path: 'get-clean',
	    name: 'get-clean',
	    component: __webpack_require__(371)
	  }, {
	    path: 'een',
	    name: 'een',
	    component: __webpack_require__(369)
	  }, {
	    path: 'hey-student',
	    name: 'hey-student',
	    component: __webpack_require__(373)
	  }, {
	    path: 'by-wood',
	    name: 'by-wood',
	    component: __webpack_require__(367)
	  }]
	}];

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	exports.default = isTouchDevice;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MainMenu = __webpack_require__(366);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    MainMenu: _MainMenu2.default
	  },
	  computed: {
	    touchClass: function touchClass() {
	      return {
	        'touch': window.isTouch,
	        'no-touch': !window.isTouch
	      };
	    }
	  },
	  watch: {
	    '$route': function $route() {
	      var transitionDuration = 300;
	      setTimeout(function () {
	        window.scrollTo(0, 0);
	      }, transitionDuration);
	    }
	  }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'about'
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'arrow',
	  props: {
	    right: Boolean,
	    active: Boolean,
	    size: String,
	    strokeWidth: Number,
	    anchor: String
	  },
	  computed: {
	    anchorClass: function anchorClass() {
	      return {
	        'anchor-right': this.anchor === 'right'
	      };
	    }
	  }
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(91);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'contact',
	  data: function data() {
	    return {
	      contact: _store2.default.contact
	    };
	  }
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hover-show',
	  props: ['images', 'title'],
	  data: function data() {
	    return {
	      animationFactor: 0.4,
	      load: false
	    };
	  },
	  mounted: function mounted() {
	    this.loadImagesIfNoTouch();
	  },
	
	  methods: {
	    loadImagesIfNoTouch: function loadImagesIfNoTouch() {
	      if (window.isTouch) return;
	      this.$nextTick(function () {
	        this.load = true;
	      });
	    }
	  }
	};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'index',
	  data: function data() {
	    return {
	      muted: 'muted',
	      showSoundControls: false
	    };
	  },
	
	  computed: {
	    soundText: function soundText() {
	      if (this.muted) return this.tapOrClick + ' for sound';
	      return this.tapOrClick + ' to mute';
	    },
	    tapOrClick: function tapOrClick() {
	      if (window.isTouch) {
	        return 'Tap';
	      }
	      return 'Click';
	    }
	  },
	  methods: {
	    enableSoundControl: function enableSoundControl() {
	      this.showSoundControls = true;
	    },
	    toggleSound: function toggleSound() {
	      this.muted = !this.muted;
	    }
	  }
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(91);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'main-menu',
	  data: function data() {
	    return {
	      projects: _projects2.default,
	      contact: _store2.default.contact,
	      links: [{
	        text: 'Contact',
	        path: '/contact'
	      }],
	      menu: {
	        open: false,
	        isTransitioning: false
	      }
	    };
	  },
	
	  computed: {
	    pathIsRoot: function pathIsRoot() {
	      return this.$route.path === '/';
	    },
	    pathIsRootClass: function pathIsRootClass() {
	      return {
	        'path-root': this.pathIsRoot
	      };
	    },
	    menuOpenClass: function menuOpenClass() {
	      return { 'menu-open': this.menu.open };
	    },
	    menuItemClass: function menuItemClass() {
	      return { 'is-black': !this.pathIsRoot };
	    }
	  },
	  watch: {
	    '$route': function $route() {
	      this.menu.isTransitioning = true;
	      this.menu.open = false;
	    }
	  },
	  methods: {
	    toggleMenu: function toggleMenu() {
	      this.menu.isTransitioning = true;
	      this.menu.open = !this.menu.open;
	    },
	    closeMenu: function closeMenu() {
	      this.menu.isTransitioning = true;
	      this.menu.open = false;
	    }
	  }
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'website-video',
	  props: ['sources', 'portrait']
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _project = __webpack_require__(43);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'clean-sound',
	  data: function data() {
	    return {
	      project: _projects2.default.find(function (project) {
	        return project.title === 'By Wood';
	      }),
	      firstSection: ['by-wood-brand-mark.png', 'by-wood-card-1.jpg', 'by-wood-card-2.jpg', 'by-wood-magazine.jpg', 'by-wood-stamp-1.jpg', 'by-wood-stamp-2.jpg', 'by-wood-stationary.jpg', 'by-wood-window.jpg', 'by-wood-word-mark.png']
	    };
	  },
	
	  mixins: [_project2.default]
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _project = __webpack_require__(43);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _automaticallyPlayVideo = __webpack_require__(52);
	
	var _automaticallyPlayVideo2 = _interopRequireDefault(_automaticallyPlayVideo);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'clean-sound',
	  data: function data() {
	    return {
	      firstSection: ['family-1.jpg', 'logo-bw.jpg', 'typography.jpg', 'tagline.jpg', 'family-packaging-2.jpg', 'wooden-box-closeup.jpg', 'record-cleaner-box-set-cropped.jpg', 'record-cleaner-action-1.jpg', 'counter-displays.jpg', 'floor-display-1.jpg'],
	      secondSection: ['clean-sound-poster-1.jpg', 'clean-sound-poster-3.jpg'],
	      thirdSection: ['subpages-clean-sound.jpg', 'product-subpage-mob.jpg'],
	      project: _projects2.default.find(function (project) {
	        return project.title === 'Clean Sound';
	      })
	    };
	  },
	
	  mixins: [_project2.default, _automaticallyPlayVideo2.default]
	};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _project = __webpack_require__(43);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _automaticallyPlayVideo = __webpack_require__(52);
	
	var _automaticallyPlayVideo2 = _interopRequireDefault(_automaticallyPlayVideo);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'clean-sound',
	  data: function data() {
	    return {
	      project: _projects2.default.find(function (project) {
	        return project.title === 'Een';
	      }),
	      firstSection: ['een-logo-1.jpg', 'een-poster-1.jpg', 'een-poster-2.jpg', 'een-poster-3.jpg', 'een-poster-outdoor-1.jpg', 'een-stationery-1.jpg', 'een-stationery-2.jpg ']
	    };
	  },
	
	  mixins: [_project2.default, _automaticallyPlayVideo2.default]
	};

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'project-footer',
	  props: ['prev', 'next'],
	  data: function data() {
	    return {
	      year: new Date().getFullYear()
	    };
	  }
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _project = __webpack_require__(43);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _automaticallyPlayVideo = __webpack_require__(52);
	
	var _automaticallyPlayVideo2 = _interopRequireDefault(_automaticallyPlayVideo);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _WebsiteVideo = __webpack_require__(123);
	
	var _WebsiteVideo2 = _interopRequireDefault(_WebsiteVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'get-clean',
	  data: function data() {
	    return {
	      project: _projects2.default.find(function (project) {
	        return project.title === 'Get Clean';
	      }),
	      identity: ['products-family.jpg', 'get-clean-logo-3.jpg', 'colours.jpg'],
	      process: ['get-clean-process.jpg'],
	      promo: ['get-clean-illustrations-1.jpg', 'get-clean-illustrations-2.jpg', 'card-together-1.jpg', 'tote-1.jpg', 't-shirts-1.jpg', 'brochure-2.jpg', 'outdoor-1.jpg'],
	      products: ['get-clean-tower-stack.jpg'],
	      packaging: ['get-clean-hanger.jpg', 'get-clean-displays.jpg']
	    };
	  },
	
	  components: {
	    WebsiteVideo: _WebsiteVideo2.default
	  },
	  mixins: [_project2.default, _automaticallyPlayVideo2.default]
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Arrow = __webpack_require__(122);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'project-header',
	  props: ['project'],
	  data: function data() {
	    return {
	      activeArrow: false
	    };
	  },
	
	  components: {
	    Arrow: _Arrow2.default
	  }
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _project = __webpack_require__(43);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'clean-sound',
	  data: function data() {
	    return {
	      project: _projects2.default.find(function (project) {
	        return project.title === 'Hey Student';
	      })
	    };
	  },
	
	  mixins: [_project2.default]
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _project = __webpack_require__(43);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _automaticallyPlayVideo = __webpack_require__(52);
	
	var _automaticallyPlayVideo2 = _interopRequireDefault(_automaticallyPlayVideo);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'incubes',
	  data: function data() {
	    return {
	      firstSection: ['Font.svg'],
	      secondSection: ['poster-1-2-web.jpg', 'poster-5-6-web.jpg', 'poster-7-8-web.jpg', 'incubes-brochure-web.jpg', 'envelope-1-2.jpg', 'business-card-1-web.jpg', 'incubes-stationery-1-web.jpg'],
	      thirdSection: ['incubes-t-shirts-web.jpg', 'tote-1-2-web.jpg', 'incubes-mobile-all.jpg'],
	      project: _projects2.default.find(function (project) {
	        return project.title === 'Incubes';
	      })
	    };
	  },
	
	  mixins: [_project2.default, _automaticallyPlayVideo2.default]
	};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'work-index'
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Preview = __webpack_require__(377);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _projects = __webpack_require__(30);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'work-overview',
	  data: function data() {
	    return {
	      projects: _projects2.default
	    };
	  },
	
	  components: {
	    ProjectPreview: _Preview2.default
	  }
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoverShow = __webpack_require__(364);
	
	var _HoverShow2 = _interopRequireDefault(_HoverShow);
	
	var _Arrow = __webpack_require__(122);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'project-preview',
	  props: ['project'],
	  data: function data() {
	    return {
	      activeArrow: false
	    };
	  },
	
	  components: {
	    HoverShow: _HoverShow2.default,
	    Arrow: _Arrow2.default
	  }
	};

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(333)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(129),
	  /* template */
	  __webpack_require__(380),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(338)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(130),
	  /* template */
	  __webpack_require__(385),
	  /* scopeId */
	  "data-v-310d9b64",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(335)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(132),
	  /* template */
	  __webpack_require__(382),
	  /* scopeId */
	  "data-v-1f1aa9be",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(336)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(133),
	  /* template */
	  __webpack_require__(383),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(332)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(134),
	  /* template */
	  __webpack_require__(379),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(341)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(135),
	  /* template */
	  __webpack_require__(388),
	  /* scopeId */
	  "data-v-4d074a07",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(331)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(137),
	  /* template */
	  __webpack_require__(378),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(344)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(138),
	  /* template */
	  __webpack_require__(391),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(348)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(139),
	  /* template */
	  __webpack_require__(395),
	  /* scopeId */
	  "data-v-94e61a42",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(347)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(140),
	  /* template */
	  __webpack_require__(394),
	  /* scopeId */
	  "data-v-843b16cc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(337)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(141),
	  /* template */
	  __webpack_require__(384),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(339)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(142),
	  /* template */
	  __webpack_require__(386),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(343)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(143),
	  /* template */
	  __webpack_require__(390),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(349)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(144),
	  /* template */
	  __webpack_require__(396),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(345)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(145),
	  /* template */
	  __webpack_require__(392),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(340)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(146),
	  /* template */
	  __webpack_require__(387),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(346)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(393),
	  /* scopeId */
	  "data-v-729b5d59",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project"
	  }, [_c('project-header', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "project-gallery row"
	  }, _vm._l((_vm.firstSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/by-wood/" + image)
	      }
	    })])
	  })), _vm._v(" "), _c('project-footer', {
	    attrs: {
	      "prev": "/work/een",
	      "next": "/work/incubes"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "index container"
	  }, [_c('video', {
	    staticClass: "index__video",
	    attrs: {
	      "playsinline": "",
	      "autoplay": "",
	      "loop": "",
	      "poster": "/static/images/bill.jpg"
	    },
	    domProps: {
	      "muted": _vm.muted
	    },
	    on: {
	      "play": _vm.enableSoundControl
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/bill.webm",
	      "type": "video/webm"
	    }
	  }), _vm._v(" "), _c('source', {
	    attrs: {
	      "src": "/static/videos/bill.mp4",
	      "type": "video/mp4"
	    }
	  })]), _vm._v(" "), (_vm.showSoundControls) ? _c('div', {
	    staticClass: "index__sound-control"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.toggleSound
	    }
	  }, [_vm._v(_vm._s(_vm.soundText))])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.touchClass,
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-fade",
	      "mode": "out-in"
	    }
	  }, [_c('router-view')], 1), _vm._v(" "), _c('main-menu')], 1)
	},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "arrow",
	    class: [{
	      'right': _vm.right,
	      'is-active': _vm.active
	    }, _vm.size, _vm.anchorClass],
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 27.48 18.38"
	    }
	  }, [(_vm.right) ? _c('g', [_c('line', {
	    staticClass: "body",
	    attrs: {
	      "stroke-width": _vm.strokeWidth,
	      "x1": "0",
	      "y1": "8.9",
	      "x2": "26",
	      "y2": "8.9"
	    }
	  }), _vm._v(" "), _c('polyline', {
	    staticClass: "head",
	    attrs: {
	      "stroke-width": _vm.strokeWidth,
	      "points": "17.7,17.2 26.1,8.8 18,0.3 "
	    }
	  })]) : _c('g', [_c('line', {
	    staticClass: "body",
	    attrs: {
	      "stroke-width": _vm.strokeWidth,
	      "x1": "26.8",
	      "y1": "8.7",
	      "x2": "0.8",
	      "y2": "8.7"
	    }
	  }), _vm._v(" "), _c('polyline', {
	    staticClass: "head",
	    attrs: {
	      "stroke-width": _vm.strokeWidth,
	      "points": "9.1,0.4 0.7,8.7 8.8,17.2 "
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-12 flex contact__inner"
	  }, [_c('div', {
	    staticClass: "contact__inquiries"
	  }, [_c('strong', [_vm._v("Inquiries")]), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "contact__email",
	    attrs: {
	      "href": ("mailto:" + (_vm.contact.email))
	    }
	  }, [_vm._v(_vm._s(_vm.contact.email))])]), _vm._v(" "), _c('div', {
	    staticClass: "contact__address"
	  }, [_c('strong', [_vm._v("Thank You For Clapping")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.contact.street)), _c('br'), _vm._v("\n        " + _vm._s(_vm.contact.postal_code) + " " + _vm._s(_vm.contact.city)), _c('br'), _vm._v("\n        " + _vm._s(_vm.contact.country) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slides"
	  }, [_vm._l((_vm.images), function(image, index) {
	    return _c('div', {
	      staticClass: "slides__slide",
	      style: ({
	        'animationDelay': ((index * _vm.animationFactor) + "s"),
	        'zIndex': _vm.images.length - index,
	        'animationDuration': ((_vm.images.length * _vm.animationFactor) + "s"),
	        'backgroundImage': index === 0 || _vm.load ? ("url(" + image + ")") : '',
	        'visibility': index > 0 ? 'hidden' : 'visible'
	      })
	    })
	  }), _vm._v(" "), _c('span', {
	    staticClass: "slides__title"
	  }, [_vm._v(_vm._s(_vm.title))])], 2)
	},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project get-clean"
	  }, [_c('project-header', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "project-gallery row"
	  }, [_c('div', {
	    staticClass: "col-12 get-clean__dirty-truth"
	  }, [_c('video', {
	    staticClass: "no-scrollplay",
	    attrs: {
	      "poster": "/static/images/get-clean/poster.jpg",
	      "playsinline": "",
	      "controls": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.target.paused ? $event.target.play() : $event.target.pause()
	      }
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/dirty_truth_video.mp4"
	    }
	  })])]), _vm._v(" "), _vm._l((_vm.identity), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/get-clean/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
	    staticClass: "col-10 col-6-md col-5-lg project-gallery__icons",
	    attrs: {
	      "src": "/static/images/get-clean/get-clean-icons-left.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "col-10 col-6-md col-5-lg project-gallery__icons project-gallery__icons--last",
	    attrs: {
	      "src": "/static/images/get-clean/get-clean-icons-right.svg"
	    }
	  }), _vm._v(" "), _vm._l((_vm.process), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/get-clean/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.packaging), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/get-clean/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._l((_vm.products), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/get-clean/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.promo), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/get-clean/" + image)
	      }
	    })])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 project-gallery__video-container"
	  }, [_c('website-video', {
	    attrs: {
	      "sources": ['/static/videos/get-clean/getclean-web-index-scroll-desktop.mp4']
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-12 project-gallery__video-container"
	  }, [_c('website-video', {
	    attrs: {
	      "sources": ['/static/videos/get-clean/get-clean-scroll-mobile.mp4'],
	      "portrait": true
	    }
	  })], 1)], 2), _vm._v(" "), _c('project-footer', {
	    attrs: {
	      "prev": "/work/clean-sound",
	      "next": "/work/incbues"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 project-gallery__fullsize-video project-gallery__double-video"
	  }, [_c('div', {
	    staticClass: "video-fix"
	  }, [_c('video', {
	    staticClass: "project-gallery__video col-12",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/get-clean-logo-gif.mp4"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "video-fix"
	  }, [_c('video', {
	    staticClass: "project-gallery__video col-12",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/get-clean-splash-gif.mp4"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 ta-center video-fix get-clean__products"
	  }, [_c('div', [_c('video', {
	    staticClass: "project-gallery__fullsize-video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/products-gif.mp4"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 get-clean__robobs"
	  }, [_c('video', {
	    attrs: {
	      "autoplay": "",
	      "muted": "",
	      "playsinline": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/dance.mp4"
	    }
	  })]), _vm._v(" "), _c('video', {
	    attrs: {
	      "autoplay": "",
	      "muted": "",
	      "playsinline": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/snow-angel.mp4"
	    }
	  })]), _vm._v(" "), _c('video', {
	    attrs: {
	      "autoplay": "",
	      "muted": "",
	      "playsinline": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/get-clean/r2d2.mp4"
	    }
	  })])])
	}]}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-12 col-4-md"
	  }, [_c('p', {
	    staticClass: "about__intro"
	  }, [_vm._v("\n        Thank You For Clapping is a creative design and development studio established in 2016. Comprising a diverse group of people with backgrounds in design, business strategy, product development, programming and creative direction, the idea behind our collective is to gather the best, creative and strategic minds to work and collaborate on design and technology-centric projects and startups.\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n        And, despite the fact that futurist, inventor and engineer Ray Kurzweil has predicted the imminent arrival of a sentient, artificial intelligence, we’re currently at a stage where technology is lifeless, inanimate, dead. This means that Siri would probably make a crappy date, even if she sometimes displays an uncanny ability for snark and that your state-of the-art vacuum cleaner won’t heart your Instagram updates even though it lovingly caresses the nooks and crannies of your living room with the affectionate determination of a seasoned housewife. Still, that doesn’t mean we can’t treat machines like they have feelings. Which some of us tend to do even when it comes to useless artifacts like broken, ageing record players.\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n        That’s because there’s poetry, emotion and subjectivity in obsolete technology. As William Gibson, the literary God of tech and sci-fi, wrote in a piece for Rolling Stone Magazine way back in 1989:\n      ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n        »I knew a man whose teen years had been L.A., jazz, the forties. He spoke of afternoons he’d spent, utterly transported, playing 78rpm recordings, “worn down white”, with repeated applications of a sharp steel stylus. That is, the shellac that carried the grooves on these originally black records was plain gone; that man heard that music.«\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-12 col-8-md about__second"
	  }, [_c('img', {
	    staticClass: "responsive-image",
	    attrs: {
	      "src": "/static/images/office-large@2x.jpg",
	      "alt": "Thank You For Clapping Office"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex"
	  }, [_c('div', {
	    staticClass: "about__text-container"
	  }, [_c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n            The love between a man and his ageing machine: slightly perverse yet totally legitimate and ultimately deeply human. So human, in fact, that numerous cultural movements were founded on similar sentiments. Where would electronic music, for example, be without a generous helping of machine fetishism?\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n            At this very moment in time, exceptionally smart and gifted engineers, scientist and other venerable nerds are doing their utmost to make the most amazing gadgets the world has ever seen. Things are moving at an incredible pace and trying to keep up with all that unrelenting innovation can, at times, be a little daunting. Your phone communicates with a satellite that hurtles around the Earth. You have more power crammed into your iPad than what a computer the size of a small house could muster in 1971. Not only do they perform well, they look incredible. Out of this world to the point where you intermittently catch yourself pondering the scientific viability of time travel.\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n            What’s more, you get the distinct feeling that the ideation and production behind these feats of engineering weren’t just motivated by profit. Don’t you think the creators want to make other people feel what they feel? Ultimately, it must be about reaching out to other people. Products that are only in it for the money are on the whole uninspiring and tedious. And this is far from being the case with the new breed of gadgets; they make you want to touch them, interact with them and, let’s face it, have them near you at all times, so that you can really, truly feel what comes out of them.\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n            The love between humans and their machines: worrying, infantile, twisted. And isn’t that’s precisely what makes it deeply and utterly human?\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text"
	  }, [_vm._v("\n            Machines may not have feelings, but they do a pretty good job of making us feel.\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "about__text-container"
	  }, [_c('p', {
	    staticClass: "about__text about__text--larger fw-700"
	  }, [_vm._v("\n            We’re a passionate bunch. More specifically, we’ve experienced first-hand what it takes to capture people’s attention and go from newly conceived idea to market-ready commercialization.\n          ")]), _vm._v(" "), _c('p', {
	    staticClass: "about__text about__text--larger fw-700"
	  }, [_vm._v("\n            In every project we engage ourselves in, the approach and execution is based on our comprehensive experience working at the intersection of technology, commerce, design and communication.\n          ")])])])])])])
	}]}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.project) ? _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('router-link', {
	    staticClass: "col-6 col-3-md header__back fw-500 c-light-grey",
	    attrs: {
	      "to": "/work",
	      "tag": "div"
	    },
	    nativeOn: {
	      "mouseenter": function($event) {
	        _vm.activeArrow = true
	      },
	      "mouseleave": function($event) {
	        _vm.activeArrow = false
	      }
	    }
	  }, [_c('arrow', {
	    attrs: {
	      "size": "large",
	      "active": _vm.activeArrow
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "row description"
	  }, [_c('div', {
	    staticClass: "col-12 col-10-md left-2-md"
	  }, [_c('h1', {
	    staticClass: "header__heading"
	  }, [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-12 col-2-md"
	  }, [(_vm.project.url) ? _c('a', {
	    staticClass: "description__website",
	    attrs: {
	      "href": ("https://" + (_vm.project.url)),
	      "target": "_blank"
	    }
	  }, [_vm._v("Visit website")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-12 col-8-md description__body"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.project.description)
	    }
	  })]), _vm._v(" "), (_vm.project.awards) ? _c('div', {
	    staticClass: "col-6 col-4-md left-2-md awards"
	  }, [_c('span', [_vm._v("Awards")]), _vm._v(" "), _c('ul', {
	    staticClass: "awards__list"
	  }, _vm._l((_vm.project.awards), function(award) {
	    return _c('li', {
	      key: award,
	      staticClass: "awards__item"
	    }, [_vm._v(_vm._s(award))])
	  }))]) : _vm._e()])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "work"
	  }, _vm._l((_vm.projects), function(project, index) {
	    return _c('project-preview', {
	      key: index,
	      attrs: {
	        "project": project
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "menu-container container"
	  }, [_c('div', {
	    staticClass: "menu",
	    class: [_vm.menuOpenClass, {
	      'is-transitioning': _vm.menu.isTransitioning
	    }],
	    on: {
	      "transitionend": function($event) {
	        _vm.menu.isTransitioning = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "menu__inner",
	    class: _vm.menuOpenClass
	  }, _vm._l((_vm.links), function(link) {
	    return _c('router-link', {
	      key: link.path,
	      staticClass: "menu__link",
	      class: [_vm.menuOpenClass, _vm.pathIsRootClass],
	      attrs: {
	        "to": link.path
	      }
	    }, [_vm._v("\n        " + _vm._s(link.text)), (link.path === '/work') ? _c('sup', {
	      staticClass: "menu__work-count"
	    }, [_vm._v("(" + _vm._s(_vm.projects.length) + ")")]) : _vm._e()])
	  }))]), _vm._v(" "), _c('router-link', {
	    staticClass: "menu__logo",
	    class: [_vm.menuOpenClass, {
	      'is-black': !_vm.pathIsRoot
	    }],
	    attrs: {
	      "to": "/"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.closeMenu($event)
	      }
	    }
	  }, [_vm._v("\n    Thank You For Clapping\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "menu__links"
	  }, _vm._l((_vm.links), function(link) {
	    return _c('router-link', {
	      key: link.path,
	      staticClass: "menu__item",
	      class: [_vm.menuItemClass],
	      attrs: {
	        "to": link.path === _vm.$route.path ? '/' : link.path
	      }
	    }, [_vm._v("\n      " + _vm._s(link.text)), (link.path === '/work') ? _c('sup', {
	      staticClass: "menu__work-count"
	    }, [_vm._v("(" + _vm._s(_vm.projects.length) + ")")]) : _vm._e()])
	  })), _vm._v(" "), _c('button', {
	    staticClass: "menu__button hamburger hover",
	    class: [_vm.menuOpenClass, {
	      'is-black': !_vm.pathIsRoot
	    }],
	    on: {
	      "click": _vm.toggleMenu
	    }
	  }, [_c('span', {
	    staticClass: "hamburger__inner"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "website",
	    class: {
	      'is-portrait': _vm.portrait
	    }
	  }, [_c('video', {
	    staticClass: "website__video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, _vm._l((_vm.sources), function(source) {
	    return _c('source', {
	      attrs: {
	        "src": source
	      }
	    })
	  })), _vm._v(" "), (!_vm.portrait) ? _c('span', {
	    staticClass: "website__bar"
	  }, [_c('span', {
	    staticClass: "website__button"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "website__button"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "website__button"
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project"
	  }, [_c('project-header', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('project-footer', {
	    attrs: {
	      "prev": "/work/get-clean",
	      "next": "/work/clean-sound"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project-gallery row"
	  }, [_c('div', {
	    staticClass: "col-12 project-gallery__img"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 project-gallery__img"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 col-5-sm project-gallery__img"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 col-5-sm project-gallery__img"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 project-gallery__img project-gallery__img--double"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 project-gallery__img"
	  })])
	}]}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project clean-sound"
	  }, [_c('project-header', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "project-gallery row"
	  }, [_vm._l((_vm.firstSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/clean-sound/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.secondSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/clean-sound/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.thirdSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/clean-sound/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('project-footer', {
	    attrs: {
	      "prev": "/work/incubes",
	      "next": "/work/get-clean"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 clean-sound__outlines"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video ",
	    attrs: {
	      "muted": "",
	      "loop": "",
	      "playsinline": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/clean-sound/clean-sound-prod-illu-gif.mp4"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 clean-sound__stack"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video",
	    attrs: {
	      "muted": "",
	      "loop": "",
	      "playsinline": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/clean-sound/poster-stack-1.mp4"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video",
	    attrs: {
	      "muted": "",
	      "loop": "",
	      "playsinline": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/clean-sound/palm-vinyl-brush.mp4"
	    }
	  })])])
	}]}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "work container"
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-fade-work",
	      "mode": "out-in"
	    }
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "preview",
	    attrs: {
	      "tag": "div",
	      "to": ("work" + (_vm.project.path))
	    }
	  }, [_c('div', {
	    staticClass: "preview__image",
	    on: {
	      "mouseenter": function($event) {
	        _vm.activeArrow = true
	      },
	      "mouseleave": function($event) {
	        _vm.activeArrow = false
	      }
	    }
	  }, [_c('hover-show', {
	    attrs: {
	      "images": [("/static/images/overview" + (_vm.project.path) + ".jpg")],
	      "title": _vm.project.title
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "preview__info"
	  }, [_c('h2', {
	    staticClass: "preview__title",
	    on: {
	      "mouseenter": function($event) {
	        _vm.activeArrow = true
	      },
	      "mouseleave": function($event) {
	        _vm.activeArrow = false
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.project.title)), _c('br'), _c('span', {
	    staticClass: "c-light-grey"
	  }, [_vm._v(_vm._s(_vm.project.year))])])])])
	},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer left-1-md"
	  }, [_c('div', {
	    staticClass: "row footer__links"
	  }, [_c('router-link', {
	    staticClass: "col-2 footer__link",
	    attrs: {
	      "to": _vm.prev
	    }
	  }, [_vm._v("Prev")]), _vm._v(" "), _c('router-link', {
	    staticClass: "col-2 left-2 left-0-md footer__link",
	    attrs: {
	      "to": _vm.next
	    }
	  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('span', {
	    staticClass: "footer__copy"
	  }, [_vm._v("© " + _vm._s(_vm.year) + " Thank Your For Clapping")])])
	},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project"
	  }, [_c('project-header', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.firstSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/een/" + image)
	      }
	    })])
	  }), _vm._v(" "), _c('project-footer', {
	    attrs: {
	      "prev": "/work/get-clean",
	      "next": "/work/by-wood"
	    }
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project-gallery row"
	  }, [_c('div', {
	    staticClass: "col-12 ta-center"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video project-gallery__video--medium",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/een/een-logo-gif.mp4"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-12 ta-center een__logo-gif"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video project-gallery__video--medium",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/een/een-logo-gif-2.mp4"
	    }
	  })])])])
	}]}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "project"
	  }, [_c('project-header', {
	    attrs: {
	      "project": _vm.project
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "project-gallery row"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._l((_vm.secondSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/incubes/" + image)
	      }
	    })])
	  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._l((_vm.thirdSection), function(image) {
	    return _c('div', {
	      key: image,
	      staticClass: "col-12 project-gallery__img"
	    }, [_c('img', {
	      staticClass: "project-gallery__image",
	      attrs: {
	        "src": ("/static/images/incubes/" + image)
	      }
	    })])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-12 project-gallery__video-container"
	  }, [_c('website-video', {
	    attrs: {
	      "sources": ['/static/videos/incubes/Incubes-15-inches-scroll.mp4']
	    }
	  })], 1)], 2), _vm._v(" "), _c('project-footer', {
	    attrs: {
	      "prev": "/work/by-wood",
	      "next": "/work/clean-sound"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 project-gallery__img"
	  }, [_c('img', {
	    staticClass: "project-gallery__image",
	    attrs: {
	      "src": "/static/images/incubes/render-1.jpg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 of-hidden video-fix"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/incubes/gif-logo-1.mp4"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 project-gallery__img project-gallery__img--incubes-logo"
	  }, [_c('img', {
	    staticClass: "project-gallery__image",
	    attrs: {
	      "src": "/static/images/incubes/incubes-logo-2.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 project-gallery__color-type"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/incubes/Font.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "/static/images/incubes/colours.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 project-gallery__video-container project-gallery__double-video project-gallery__double-video--incubes"
	  }, [_c('video', {
	    staticClass: "col-12 col-5-sm project-gallery__video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/incubes/gif-shapes-1.mp4"
	    }
	  })]), _vm._v(" "), _c('video', {
	    staticClass: "col-12 col-5-sm project-gallery__video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/incubes/gif-shapes-2.mp4"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12 project-gallery__video-container"
	  }, [_c('video', {
	    staticClass: "col-12 col-8-sm project-gallery__video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/incubes/gif-poster-1.mp4"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-12"
	  }, [_c('video', {
	    staticClass: "project-gallery__fullsize-video",
	    attrs: {
	      "playsinline": "",
	      "muted": "",
	      "loop": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "/static/videos/incubes/gif-incubes-presentation-brochure.mp4"
	    }
	  })])])
	}]}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.8c5a82cba9f94d7e624d.js